angular
    .module('festzelt-os.guestlists')
    .factory('printOverviewDocumentsForRsvps', [
            '$injector',
            ($injector) => new PrintOverviewDocumentsForRsvps($injector)
        ]
    );

class PrintOverviewDocumentsForRsvps {
    constructor($injector) {
        this.injector = $injector;
        this.api = $injector.get('$http')
        this.alert = $injector.get('Alert')

        this.key = 'print-overview-documents-for-rsvps';
        this.title = 'Print overview documents';
        this.level = 'selected';
    }

    action(action, store, newValue) {
        const dataForRequest = {
            ...store.getters.selectedFilters,
            guestlist_id: _.get(store.state, 'vm.guestlist.id', null)
        };

        this.api.post('rsvps/print-overviews', {
            rsvps: dataForRequest
        })
            .then(() => {
                this.alert.success('started', 'Print of rsvp overviews started');
            })
            .catch(e => {
                this.alert.handle(e)
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/rsvps-list/print-overview-documents-for-rsvps.js